import type { CSSProperties } from 'react';

const WAVES_IMG = `${process.env.PUBLIC_URL || ''}/images/waves.png`;

/** Teal–blue gradient wave lines (waves.png) with soft fade at left/right edges. */
export default function ResourcesHeroWaves() {
  const maskStyle = { '--waves-mask': `url("${WAVES_IMG}")` } as CSSProperties;

  return (
    <div className="resources-hero-waves" aria-hidden>
      <div className="resources-hero-waves__art" style={maskStyle} />
    </div>
  );
}
